/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "bankAddress",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "EnumerableSet__IndexOutOfBounds",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "AcceptAsk",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "AcceptBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "CancelAsk",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "CancelBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "CreateAsk",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "CreateBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "REVERT_ASK_DOES_NOT_EXIST",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_ASK_INSUFFICIENT_VALUE",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_ASK_IS_RESERVED",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_ASK_SELLER_NOT_OWNER",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_BID_TOO_LOW",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_CANT_ACCEPT_OWN_ASK",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_EXISTED_TOKEN",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_INSUFFICIENT_ETHER",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_INVALID_MARKET_NAME",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_INVALID_TOKEN_ADDRESS",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_LISTING_TYPE_ERROR",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_MARKET_NAME_OCCUPIED",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_MARKET_NAME_REQUIRED",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_NFT_NOT_SENT",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_NOT_A_CREATOR_OF_ASK",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_NOT_A_CREATOR_OF_BID",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_NOT_OWNER_OF_TOKEN_ID",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_ORDER_NOT_FOUND",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_OWNER_OF_TOKEN_ID",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_PERMISSION_DENIED",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REVERT_WRONG_LISTING_TYPE",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "bytes32[]",
                name: "id",
                type: "bytes32[]",
            },
            {
                internalType: "uint256[]",
                name: "quantity",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "feeStrategy",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "feeTakers",
                type: "address[]",
            },
        ],
        name: "acceptAsk",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "bytes32[]",
                name: "id",
                type: "bytes32[]",
            },
            {
                internalType: "uint256[]",
                name: "quantity",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "feeStrategy",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "feeTakers",
                type: "address[]",
            },
        ],
        name: "acceptBid",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "addFeatured",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "addTokenToMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
        ],
        name: "asks",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quantity",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "nft",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                ],
                internalType: "struct IMarketplace.Order[]",
                name: "orders",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "wallet",
                type: "address",
            },
        ],
        name: "asksByWallet",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quantity",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "nft",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                ],
                internalType: "struct IMarketplace.Order[]",
                name: "orders",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "nft",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
        ],
        name: "bids",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quantity",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "nft",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                ],
                internalType: "struct IMarketplace.Order[]",
                name: "orders",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "wallet",
                type: "address",
            },
        ],
        name: "bidsByWallet",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quantity",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "nft",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                ],
                internalType: "struct IMarketplace.Order[]",
                name: "orders",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "bytes32[]",
                name: "id",
                type: "bytes32[]",
            },
        ],
        name: "cancelAsk",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "bytes32[]",
                name: "id",
                type: "bytes32[]",
            },
        ],
        name: "cancelBid",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "collection",
                type: "address",
            },
        ],
        name: "collectionInfo",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "name",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "description",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "website",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "image",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "rule",
                        type: "address",
                    },
                    {
                        internalType: "enum IMarketplace.NFTType",
                        name: "kind",
                        type: "uint8",
                    },
                    {
                        internalType: "enum IMarketplace.ListingType",
                        name: "listingType",
                        type: "uint8",
                    },
                ],
                internalType: "struct IMarketplace.CollectionInfo",
                name: "collectionInfoRet",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
            {
                internalType: "enum IMarketplace.ListingType",
                name: "kind",
                type: "uint8",
            },
        ],
        name: "collections",
        outputs: [
            {
                internalType: "address[]",
                name: "listedCollections",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
            {
                internalType: "enum IMarketplace.ListingType",
                name: "kind",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "collectionsPiece",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "name",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "description",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "website",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "image",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "rule",
                        type: "address",
                    },
                    {
                        internalType: "enum IMarketplace.NFTType",
                        name: "kind",
                        type: "uint8",
                    },
                    {
                        internalType: "enum IMarketplace.ListingType",
                        name: "listingType",
                        type: "uint8",
                    },
                ],
                internalType: "struct IMarketplace.CollectionInfo",
                name: "collectionInfoRet",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
            {
                internalType: "enum IMarketplace.ListingType",
                name: "kind",
                type: "uint8",
            },
        ],
        name: "collectionsSize",
        outputs: [
            {
                internalType: "uint256",
                name: "listedCollectionsSize",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "price",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "quantity",
                type: "uint256[]",
            },
        ],
        name: "createAsk",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INFTContract[]",
                name: "nft",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "tokenID",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "price",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "quantity",
                type: "uint256[]",
            },
        ],
        name: "createBid",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
        ],
        name: "createMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "deleteFeatured",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "marketName",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "enum IMarketplace.ListingType",
                name: "kind",
                type: "uint8",
            },
        ],
        name: "deleteTokenFromMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "escrow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "nftAddress",
                type: "address",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "website",
                type: "string",
            },
            {
                internalType: "string",
                name: "image",
                type: "string",
            },
            {
                internalType: "enum IMarketplace.NFTType",
                name: "nftType",
                type: "uint8",
            },
            {
                internalType: "enum IMarketplace.ListingType",
                name: "listingType",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "rule",
                type: "address",
            },
        ],
        name: "listToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "nft",
                type: "address",
            },
        ],
        name: "listings",
        outputs: [
            {
                internalType: "uint256[]",
                name: "tokens",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "collection",
                type: "address",
            },
            {
                internalType: "address",
                name: "wallet",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "listingsPiece",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "name",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "description",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "website",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "image",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "rule",
                        type: "address",
                    },
                    {
                        internalType: "enum IMarketplace.NFTType",
                        name: "kind",
                        type: "uint8",
                    },
                    {
                        internalType: "enum IMarketplace.ListingType",
                        name: "listingType",
                        type: "uint8",
                    },
                ],
                internalType: "struct IMarketplace.CollectionInfo",
                name: "collectionInfoRes",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "balance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string",
                    },
                ],
                internalType: "struct IMarketplace.TokenInfo",
                name: "baseInfo",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quantity",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "nft",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                ],
                internalType: "struct IMarketplace.Order[]",
                name: "asksRes",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quantity",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "nft",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                ],
                internalType: "struct IMarketplace.Order[]",
                name: "bidsRes",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "nft",
                type: "address",
            },
        ],
        name: "listingsSize",
        outputs: [
            {
                internalType: "uint256",
                name: "size",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "marketsByOwner",
        outputs: [
            {
                internalType: "string[]",
                name: "markets",
                type: "string[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "website",
                type: "string",
            },
            {
                internalType: "string",
                name: "image",
                type: "string",
            },
            {
                internalType: "enum IMarketplace.NFTType",
                name: "kind",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "rule",
                type: "address",
            },
        ],
        name: "modifyTokenInfo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onERC1155BatchReceived",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onERC1155Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "prices",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "sales",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "collection",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "wallet",
                type: "address",
            },
        ],
        name: "tokenInfo",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "name",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "description",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "website",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "image",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "rule",
                        type: "address",
                    },
                    {
                        internalType: "enum IMarketplace.NFTType",
                        name: "kind",
                        type: "uint8",
                    },
                    {
                        internalType: "enum IMarketplace.ListingType",
                        name: "listingType",
                        type: "uint8",
                    },
                ],
                internalType: "struct IMarketplace.CollectionInfo",
                name: "collectionInfoRes",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quantity",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "nft",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                ],
                internalType: "struct IMarketplace.Order[]",
                name: "asksRes",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quantity",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "nft",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                ],
                internalType: "struct IMarketplace.Order[]",
                name: "bidsRes",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "balance",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string",
                    },
                ],
                internalType: "struct IMarketplace.TokenInfo",
                name: "baseInfo",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalMarkets",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferTokenOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class Marketplace__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(bankAddress, overrides) {
        return super.deploy(bankAddress, overrides || {});
    }
    getDeployTransaction(bankAddress, overrides) {
        return super.getDeployTransaction(bankAddress, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
Marketplace__factory.bytecode = _bytecode;
Marketplace__factory.abi = _abi;
